<div class="title" mat-dialog-title>
    <mode-dialog-header>
      <h1 class="dialog-heading" heading>Republish Dataset?</h1>
    </mode-dialog-header>
  </div>
  <section class="body">
    <p class="text">This makes the latest set of Dataset changes available to the corresponding table in the Data Workspace</p>
    <p class="sub-title">To republish, make sure that:</p>
    <ul>
      <li>the Dataset is in the same Collection it was originally published in</li>
      <li>the Dataset name is unchanged</li>
    </ul>
  </section>
  <mode-status-banner show-icon="true" class="info-banner" status="infoWarning" layout="full-width">
    <span>Changes to in-use columns may not be reflected until dependencies are resolved.
        <a href="https://docs.thoughtspot.com/cloud/10.8.0.cl/analyst-studio-datasets" target="_blank">Learn more</a>
    </span>
  </mode-status-banner>
  <div mat-dialog-actions>
    <capra-button
      class="cancel-btn"
      text="Cancel"
      data-test="cancel-republish-dataset"
      variant="secondary"
      color="neutral"
      modeTrackClick
      [trackClickData]="{ location: 'Republish dataset modal', action: 'Republish dataset close CTA' }"
      (clicked)="close()"
    ></capra-button>
    <capra-button
      text="Republish"
      data-test="republish-dataset"
      modeTrackClick
      [trackClickData]="{ location: 'Republish dataset modal', action: 'Republish dataset CTA' }"
      (clicked)="republishDataset()"
    ></capra-button>
  </div>